import { gql } from '@apollo/client';
import TENANT_SUPPLIER from 'api/fragments/TENANT_SUPPLIER';
const ARCHIVE_TENANT_SUPPLIER = gql `
  ${TENANT_SUPPLIER}
  mutation ArchiveTenantSupplier($supplierId: ID!) {
    archiveSupplier(supplierId: $supplierId) {
      supplier {
        ...TenantSupplierFragment
      }
    }
  }
`;
export default ARCHIVE_TENANT_SUPPLIER;
